<template>
  <section class="connect-bridge">
    <v-card dark flat class="connect-card">
      <span class="connect-icon"><v-icon>mdi-forum-outline</v-icon></span>
      <div class="eyebrow">Leadership Connect</div>
      <h2>{{ error ? "Connect konnte nicht geöffnet werden" : "Geschützten Austausch öffnen" }}</h2>
      <p v-if="error">{{ error }}</p>
      <p v-else>Deine Berechtigung und die Mitgliedschaft im Leadership-Channel werden geprüft.</p>
      <v-progress-linear v-if="loading" indeterminate color="#58d388" background-color="rgba(255,255,255,0.08)" rounded />
      <div v-if="error" class="actions">
        <v-btn outlined color="#58d388" class="secondary-action" to="/akademie/leadership">Zurück</v-btn>
        <v-btn color="#009640" depressed class="primary-action" :loading="loading" @click="openConnect">Erneut versuchen</v-btn>
      </div>
    </v-card>
  </section>
</template>

<script>
import api from "@/api"

export default {
  name: "LeadershipConnect",
  data() {
    return { loading: false, error: "" }
  },
  mounted() {
    this.openConnect()
  },
  methods: {
    async openConnect() {
      this.loading = true
      this.error = ""
      try {
        const result = await api.fetchLeadershipConnect()
        const groupId = result && (result.groupId || result._id || (result.group && result.group._id))
        if (!groupId) throw new Error("Der Leadership-Channel ist noch nicht eingerichtet.")
        await this.$router.replace({ path: "/chat", query: { groupId, from: "academy" } })
      } catch (error) {
        this.error =
          (error.response && error.response.data && (error.response.data.error || error.response.data.message || error.response.data.msg)) ||
          error.message ||
          "Bitte versuche es später erneut."
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.connect-bridge {
  display: grid;
  min-height: 24rem;
  place-items: center;
  color: #f4f4f5;
  font-size: 1rem;
}

.connect-card {
  display: grid;
  width: min(100%, 36rem);
  justify-items: center;
  gap: 0.75rem;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1.25rem !important;
  background: radial-gradient(circle at 50% 0, rgba(0, 150, 64, 0.14), transparent 15rem), rgba(255, 255, 255, 0.035) !important;
  text-align: center;
}

.connect-icon {
  display: grid;
  width: 4rem;
  height: 4rem;
  place-items: center;
  border-radius: 1.125rem;
  color: #7ee5a6;
  background: rgba(0, 150, 64, 0.15);
}

.connect-icon .v-icon {
  color: currentColor;
  font-size: 2rem;
}

.eyebrow {
  color: #7ee5a6;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

h2 {
  margin: 0;
  color: #fff;
  font-size: 1.5rem;
}

p {
  margin: 0 0 0.5rem;
  color: #c7c7cb;
  font-size: 1rem;
  line-height: 1.55;
}

.connect-card .v-progress-linear {
  width: 100%;
}

.actions {
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.primary-action,
.secondary-action {
  min-height: 2.75rem !important;
  border-radius: 0.875rem !important;
  font-size: 0.875rem !important;
  font-weight: 750;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 37.5rem) {
  .connect-card {
    padding: 1.25rem;
  }

  .actions {
    flex-direction: column-reverse;
  }
}
</style>
